"use client";

import React from "react";
import { ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const guarantee = {
  title: "Risk-Free Care. Real Confidence.",
  paragraph: "At IronPeak Men’s Health, we stand behind the quality of our care. Try any service for 30 days — if you are not 100% satisfied, we will make it right or refund your money."
};
export default function TrustCredentialsCatalog() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="253407" id="theguarantee" className="relative py-8 md:py-12 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1375869/img/mens_health_clinic_texture.png)] bg-background text-foreground overflow-hidden">
      <div className="absolute inset-0 bg-background/90 backdrop-blur-[1px]"></div>

      <div className="page-container relative z-10">
        <div ref={ref} className={`max-w-5xl mx-auto transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="bg-card text-card-foreground rounded-2xl border border-border shadow-soft overflow-hidden">
            <div className="px-5 pt-6 pb-5 md:px-8 md:pt-8 md:pb-6 text-center">
              <div className="inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary-light-bg px-4 py-2 mb-4">
                <ShieldCheck className="w-4 h-4 text-primary" />
                <span className="text-sm font-semibold text-primary">
                  30-Day Satisfaction Guarantee
                </span>
              </div>

              <h3 className="text-2xl md:text-3xl font-default font-bold mb-3 tracking-tight text-foreground">
                {guarantee.title}
              </h3>

              <p className="text-muted-dark font-default text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
                {guarantee.paragraph}
              </p>
            </div>

            <div className="px-3 pb-3 md:px-5 md:pb-5">
              <img src="https://ironpeakmenshealth.com/wp-content/uploads/2026/05/30-day-guarantee.png" alt="IronPeak Men’s Health 30-day unconditional guarantee" className="w-full max-w-4xl mx-auto rounded-xl shadow-medium" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}